import { render, staticRenderFns } from "./FlowCategoryList.vue?vue&type=template&id=4b2e0f1c&scoped=true"
import script from "./FlowCategoryList.vue?vue&type=script&lang=js"
export * from "./FlowCategoryList.vue?vue&type=script&lang=js"
import style0 from "./FlowCategoryList.vue?vue&type=style&index=0&id=4b2e0f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2e0f1c",
  null
  
)

export default component.exports